module.exports = __webpack_public_path__ + "img/listbg.05d1b779.png";